<template>
  <el-container class="view-content portalTemplate">
    <el-header class="header-content">
      <el-row type="flex" justify="space-between" align="middle">
        <statistics :count-list="countList"/>
        <el-button-group>
          <el-button size="small" type="primary" @click="setDefault" :disabled="selectId === defaultId">默认Portal</el-button>
          <el-button size="small" type="primary" @click="showUploadTemplate">上传模板</el-button>
          <el-button size="small" type="primary" :disabled="!selectId" @click="remove">删除模板</el-button>
        </el-button-group>
      </el-row>
    </el-header>
    <el-main class="main-content">
      <el-card>
        <el-radio-group class="imgBox" v-model="selectId" v-if="list.length">
          <el-radio-button v-for="item in list" :key="item.id" :label="item.id">
            <div data-text="Portal" class="banner" v-if="defaultId === item.id"></div>
            <el-image class="image" :src="item.img_path" />
            <p class="name">{{item.name}}</p>
            <p class="remark" :title="item.remark">{{item.remark}}</p>
          </el-radio-button>
        </el-radio-group>
        <p class="empty" v-else>暂无模板</p>
      </el-card>
    </el-main>
    <el-footer class="footer-content">
      <vue-pagination :paging-data="pagingData" @table-reload="getTableList" ref="paging" layout="prev, pager, next" small/>
    </el-footer>
    <upload-template v-if="uploadTemplate.visible" :dialog-data="uploadTemplate" @table-reload="getTableList"/>
  </el-container>
</template>

<script>
  import {PagingData} from "@mixins"
  import Statistics from "@view/components/Statistics"
  import UploadTemplate from "./dialog/UploadTemplate"
  export default {
    name: "defaultTemplate",
    mixins: [PagingData],
    components: {Statistics,UploadTemplate},
    data() {
      return {
        // 统计
        countList: [
          {name: "模板总数", count: 0},
        ],
        selectId: "",
        defaultId: "",
        list: [],
        uploadTemplate: {title: "上传模板", visible: false, width: 450}
      }
    },
    methods: {
      showUploadTemplate() {
        this.uploadTemplate.visible = true;
      },
      setDefault() {
        this.openConfirm("设为默认Portal", async ()=> {
          let nv = {template_id: this.selectId};
          let res = await this.$Http.setPortalDefault(nv);
          if (res) {
            this.selectId = "";
            this.msgSuccess("设置成功");
            this.getTableList();
          }
        });
      },
      remove() {
        this.openConfirm("删除该模板", async ()=> {
          let nv = {optionId: this.selectId};
          let res = await this.$Http.deletePortalTemplate(nv);
          if (res) {
            this.selectId = "";
            this.msgSuccess("删除成功");
            this.$refs["paging"].removeFinish(1);
            this.getTableList();
          }
        });
      },
      //获取表格数据
      async getTableList() {
        let nv = {
          page: this.pagingData.currentPage,
          limit: this.pagingData.pageSize
        };
        let res = await this.$Http.getPortalTemplate(nv);
        if (res?.data) {
          let total = +res.data.total || 0;
          this.pagingData.total = total;
          this.countList[0].count = total;
          this.list = this.getArray(res.data.list);
          this.defaultId = res.data.template_id;
        }
      },
    },
    created() {
      this.getTableList();
    }
  }
</script>

<style lang="scss" scoped>
  .portalTemplate {
    /deep/ {
      .imgBox {
        .el-radio-button {
          margin: 0 20px 40px 0;
          .el-radio-button__inner {
            padding: 10px;
            border-radius: 0;
            border: 1px solid $input-border-color;
            width: 225px;
            &:hover {
              border-color: $home-color;
            }
            .banner {
              position: absolute;
              top: -43px;
              left: -44px;
              width: 48px;
              height: 48px;
              border: 18px solid;
              border-color: transparent transparent $danger-color;
              transform: rotate(315deg);
              z-index: 10;
              &:after {
                position: absolute;
                content: attr(data-text);
                color: #fff;
                font-size: 12px;
                top: 50px;
                left: 14px;
              }
            }
          }
          .el-radio-button__orig-radio:checked+.el-radio-button__inner {
            border-color: $home-color;
          }
        }
        .image {
          height: 365px;
          display: block;
          cursor: pointer;
        }
        .name,
        .remark {
          overflow: hidden;
          text-align: center;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
        .name {
          padding: 10px 0 5px;
        }
        .remark {
          position: absolute;
          bottom: 0;
          left: 0;
          right: 0;
          transform: translateY(25px);
          color: #aaa!important;
        }
      }
      .empty {
        font-size: 14px;
        text-align: center;
        color: #909399;
      }
    }
  }
  @media screen and (max-width: 450px) {
    .portalTemplate {
      /deep/ {
        .imgBox {
          display: flex;
          flex-direction: column;
          align-items: center;
          .el-radio-button {
            margin-right: 0;
          }
        }
      }
    }
  }
</style>
